"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Styled = __importStar(require("./Textarea.styled"));
var Textarea = function (_a, ref) {
    var id = _a.id, required = _a.required, label = _a.label, description = _a.description, className = _a.className, _b = _a.errorMessage, errorMessage = _b === void 0 ? '' : _b, restProps = __rest(_a, ["id", "required", "label", "description", "className", "errorMessage"]);
    return ((0, jsx_runtime_1.jsxs)(Styled.TextareaWrapper, __assign({ className: className }, { children: [label && ((0, jsx_runtime_1.jsxs)(Styled.TextareaLabel, __assign({ htmlFor: id }, { children: [(0, jsx_runtime_1.jsx)("span", { children: label }, void 0), required && (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }), void 0)), description && (0, jsx_runtime_1.jsx)(Styled.Description, { children: description }, void 0), (0, jsx_runtime_1.jsx)(Styled.Textarea, __assign({ ref: ref }, restProps), void 0), errorMessage && (0, jsx_runtime_1.jsx)(Styled.TextareaErrorMessage, { children: errorMessage }, void 0)] }), void 0));
};
exports.default = (0, react_2.forwardRef)(Textarea);
